<template>
  <div align="center" class="has-text-centered">
    <div class="m-3 p-3">
      <!--remerciements FR -->
      <div v-if="this.$store.state.langage.langue === 'fr'" class="thanks">
        <h2 v-if="insight_thanks_fr !== undefined">
          {{ this.insight_thanks_fr }}
        </h2>
        <h2 v-if="thanks_fr == 'fr'">{{ $t("public.merci") }}</h2>
      </div>
      <!--remerciements EN -->
      <div v-if="this.$store.state.langage.langue === 'en'" class="thanks">
        <h2 v-if="insight_thanks_en !== undefined">
          {{ this.insight_thanks_en }}
        </h2>
        <h2 v-if="thanks_en == 'en'">{{ $t("public.merci") }}</h2>
      </div>
      <div align="center" class="mt-3 mb-3 field">
        <router-link :to="'/i-' + this.urlparticipant">
          <p style="width:180px;" class="mt-1 lien_retour button-primary">
            {{ $t("button.public.retour") }}{{ " " }}
          </p>
        </router-link>
      </div>
      <p v-if="this.counter > 1">
        {{ $t("remerciements.redirected") }}{{ this.counter
        }}{{ $t("remerciements.seconds") }}
      </p>
      <p v-if="this.counter <= 1">
        {{ $t("remerciements.redirected") }}{{ this.counter
        }}{{ $t("remerciements.second") }}
      </p>
    </div>
  </div>
</template>
<script>
import EventBus from "../../../eventBus";
import { mapGetters } from "vuex";

export default {
  props: ["urlparticipant", "thanks"],
  data() {
    return {
      counter: 10,
      myTimer: 0,
      thanks_fr: "",
      thanks_en: "",
    };
  },
  computed: {
    ...mapGetters(["insight_finish"]),
    insight_thanks_fr() {
      if (this.thanks) {
        const thanks_fr = this.thanks.split("¤");
        if (thanks_fr[0] !== "") return thanks_fr[0];
        else this.thanks_fr = "fr";
      } else this.thanks_fr = "fr";
    },
    insight_thanks_en() {
      if (this.thanks) {
        const thanks_en = this.thanks.split("¤");
        if (thanks_en[1] !== "") return thanks_en[1];
        else this.thanks_en = "en";
      } else this.thanks_en = "en";
    },
  },
  created() {
    EventBus.$on("counterDown", this.counterDown());
  },
  methods: {
    resetTimer() {
      clearInterval(this.myTimer);
      this.$router.push({ name: "Inscription" });
    },
    counterDown() {
      this.myTimer = setInterval(() => {
        if (this.counter > 1) {
          return (this.counter -= 1);
        } else {
          return this.resetTimer();
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.button {
  padding: 20px;
}
.deplacement-right-icon {
  margin-left: 10px;
}
.lien_retour:hover .deplacement-right-icon {
  margin-left: 15px;
}
</style>
